import { artifactCrudConfig, type Artifact } from '@/config/objects/artifacts';
import { CrudListView, type CrudConfig, type CrudListHeaderAction } from '@startupquickstart/frontend';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

interface ArtifactsListProps {
  config?: CrudConfig<Artifact>;
  defaultWhere?: Record<string, unknown>;
  onItemClick?: (artifact: Artifact) => void;
  className?: string;
  baseUrl?: string;
  headerActions?: CrudListHeaderAction[];
  breadcrumbs?: Array<{ label: string; href?: string; current?: boolean }>;
}

export function ArtifactsList({
  config,
  baseUrl = '/artifacts',
  defaultWhere,
  onItemClick,
  className,
  headerActions,
  breadcrumbs,
}: ArtifactsListProps) {
  const navigate = useNavigate();

  const _onItemClick = useCallback(
    (artifact: Artifact) => {
      if (onItemClick) {
        onItemClick(artifact);
      } else {
        navigate(`/artifacts/${artifact.id}`);
      }
    },
    [navigate, onItemClick],
  );

  return (
    <div className={className}>
      <CrudListView
        config={config || artifactCrudConfig}
        baseUrl={baseUrl}
        onItemClick={_onItemClick}
        defaultWhere={defaultWhere}
        headerActions={headerActions}
        breadcrumbs={breadcrumbs}
        getValueFromItem={(artifact: Artifact) => artifact.id}
        getLabelFromItem={(artifact: Artifact) => artifact.name}
      />
    </div>
  );
}
